var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "reviews" } },
    [
      _vm.loading
        ? _c("div", [_c("device-details-reviews-skeleton")], 1)
        : [
            _c(
              "div",
              { staticClass: "d-flex flex-row justify-content-between" },
              [
                _c("div", { staticClass: "pb-1 lead fw-bold" }, [
                  _vm.deviceReviews.length > 0
                    ? _c("div", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.reviewsOffsetMessage) +
                            "\n                "
                        ),
                      ])
                    : _c("div", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.reviewsMessages.noResultReviewsMessage) +
                            "\n                "
                        ),
                      ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-md-none" },
                  [
                    _c("ob1-liens-icone", {
                      staticClass: "noDefaultStyleButton",
                      attrs: {
                        "is-button": "",
                        mini: true,
                        "modal-id": "slide-filters-reviews-modal",
                        title: "Filtrer",
                        "data-bs-toggle": "modal",
                        icon: "icon-filter",
                        type: "button",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("reviews-details", {
              attrs: {
                "device-reviews": _vm.deviceReviews,
                verified: _vm.reviewsMessages.verified,
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }